/* eslint-disable camelcase */

export type VerificationStatus =
  | 'CREATED'
  | 'SUBMITTED'
  | 'VERIFIED'
  | 'FLAGGED'
  | 'REVIEWED'
  | 'DENIED'
  | 'FAILED'
  | 'VALID'
  | 'INVALID'
  | 'ACTIVE'
  | null;

export type TFNVerificationStatus = Exclude<VerificationStatus, 'ACTIVE'>;

export const TFNVerificationStatuses = {
  INVALID: 'INVALID',
  FLAGGED: 'FLAGGED',
  FAILED: 'FAILED',
  DENIED: 'DENIED',
  VERIFIED: 'VERIFIED',
} as const;

export type ShopperVerificationStatus = Extract<
  VerificationStatus,
  'ACTIVE' | 'DENIED'
>;

export interface TFNVerificationRequest {
  id: number;
  shop_id: number;
  messaging_service_id: number;
  status: TFNVerificationStatus;
  created_at: string;
  updated_at: string;
  rejection_code: number | null;
}

export interface TFNVerificationRequestsResponse {
  requests: TFNVerificationRequest[];
}

export interface TFNRequestResponse {
  success: boolean;
  message: string;
  verificationRequestId: number;
}

export const TFNReverificationModalType = {
  UNREACHABLE_WEBSITE: 'UNREACHABLE_WEBSITE',
  PASSWORD_PROTECTED_WEBSITE: 'PASSWORD_PROTECTED_WEBSITE',
  INVALID_BUSINESS_EMAIL: 'INVALID_BUSINESS_EMAIL',
  INVALID_CONTACT: 'INVALID_CONTACT',
  INVALID_ADDRESS: 'INVALID_ADDRESS',
  INVALID_BUSINESS_REGISTRATION: 'INVALID_BUSINESS_REGISTRATION',
  INVALID_BUSINESS_INFO: 'INVALID_BUSINESS_INFO',
  UNKNOWN: 'UNKNOWN',
} as const;

export type TFNReverificationModalType =
  typeof TFNReverificationModalType[keyof typeof TFNReverificationModalType];
